import { render, staticRenderFns } from "./pay-table.vue?vue&type=template&id=24db92cc&scoped=true"
import script from "./pay-table.vue?vue&type=script&lang=js"
export * from "./pay-table.vue?vue&type=script&lang=js"
import style0 from "./pay-table.vue?vue&type=style&index=0&id=24db92cc&prod&lang=less&scoped=true"
import style1 from "./pay-table.vue?vue&type=style&index=1&id=24db92cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db92cc",
  null
  
)

export default component.exports